import { Linkedin, Instagram, Twitter } from "lucide-react";
import Logo from "./Logo";
import { COPY } from "@/content/copy";

const Footer = () => {
  return (
    <footer 
      className="bg-flexaura-navy text-white py-16 px-4"
      role="contentinfo"
      aria-label="Site footer"
    >
      <div className="max-w-6xl mx-auto">
        {/* Enhanced footer content with better SEO structure */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12">
          {/* Company Info */}
          <div className="md:col-span-1">
            <Logo className="text-white mb-4" />
            <p className="text-sm text-white/80 font-body mb-4">
              {COPY.footerTagline}
            </p>
            <div className="flex gap-4">
              <a 
                href="https://linkedin.com/company/flexaura" 
                className="p-2 hover:bg-white/10 rounded-lg smooth-transition"
                aria-label="Follow Flexaura on LinkedIn"
              >
                <Linkedin className="w-5 h-5" />
              </a>
              <a 
                href="https://instagram.com/flexaura" 
                className="p-2 hover:bg-white/10 rounded-lg smooth-transition"
                aria-label="Follow Flexaura on Instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a 
                href="https://twitter.com/flexaura" 
                className="p-2 hover:bg-white/10 rounded-lg smooth-transition"
                aria-label="Follow Flexaura on Twitter"
              >
                <Twitter className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-heading font-semibold text-white mb-4">Services</h3>
            <nav className="flex flex-col gap-3">
              <a href="/pay-monthly-travel" className="text-white/80 hover:text-flexaura-teal smooth-transition">
                Travel Finance
              </a>
              <a href="/pay-monthly-education" className="text-white/80 hover:text-flexaura-teal smooth-transition">
                Education Finance
              </a>
              <a href="/pay-monthly-healthcare" className="text-white/80 hover:text-flexaura-teal smooth-transition">
                Healthcare Finance
              </a>
              <a href="/marketplace" className="text-white/80 hover:text-flexaura-teal smooth-transition">
                Marketplace
              </a>
            </nav>
          </div>

          {/* Company */}
          <div>
            <h3 className="font-heading font-semibold text-white mb-4">Company</h3>
            <nav className="flex flex-col gap-3">
              <a href="/about" className="text-white/80 hover:text-flexaura-teal smooth-transition">
                About Us
              </a>
              <a href="/investors" className="text-white/80 hover:text-flexaura-teal smooth-transition">
                Investors
              </a>
              <a href="/contact" className="text-white/80 hover:text-flexaura-teal smooth-transition">
                Contact
              </a>
              <a href="mailto:hector@flexaura.me" className="text-white/80 hover:text-flexaura-teal smooth-transition">
                Support
              </a>
            </nav>
          </div>

          {/* Legal */}
          <div>
            <h3 className="font-heading font-semibold text-white mb-4">Legal</h3>
            <nav className="flex flex-col gap-3">
              <a href="/privacy" className="text-white/80 hover:text-flexaura-teal smooth-transition">
                Privacy Policy
              </a>
              <a href="/terms" className="text-white/80 hover:text-flexaura-teal smooth-transition">
                Terms of Service
              </a>
              <a href="/refund" className="text-white/80 hover:text-flexaura-teal smooth-transition">
                Refund Policy
              </a>
            </nav>
          </div>
        </div>
        
        <div className="border-t border-white/20 pt-8 text-center">
          <p className="text-sm text-white/70 font-body">
            © {new Date().getFullYear()} Flexaura. All rights reserved. | Monthly payment solutions for travel, education, and healthcare.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;